import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-addtax',
  templateUrl: './addtax.component.html',
  styleUrls: ['./addtax.component.css']
})
export class AddtaxComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  taxrate: number = 0
  //Edit Get Values
  settingscompanyColl: any = [];
  taxColl: any = [];
  taxid: number = 0

  taxform = new FormGroup({
    taxid: new FormControl(0),
    taxname: new FormControl('', Validators.required),
    taxrate: new FormControl(null, Validators.required),
    cgsttaxrate: new FormControl(null),
    sgsttaxrate: new FormControl(null),
    igsttaxrate: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Tax";

  taxtype:String=""
  istaxtyperead: boolean = false;

  @Input() taxname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.taxid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.taxform.reset();
      this.fnInitializetax();

      if (this.taxid > 0) {
        this.fngetTax();
      }
     

      this.taxtype = this.loginService.userBO.taxtype;
      
      if (this.taxtype === 'GST') { 
        this.istaxtyperead=true
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.taxid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializetax() {
    this.taxform.setValue({

      taxid: 0,
      taxname: '',
      taxrate: null,
      cgsttaxrate: null,
      sgsttaxrate: null,
      igsttaxrate: null,
      inactive: false,
    })
  }



  //Get 
  fngetTax() {

    var data = {
      'taxid': this.taxid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;
          var editdata = this.taxColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.taxform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'taxid': this.taxid,
          'taxname': this.taxform.get('taxname').value,
          'taxrate': this.taxform.get('taxrate').value,
          'cgsttaxrate': this.taxform.get('cgsttaxrate').value,
          'sgsttaxrate': this.taxform.get('sgsttaxrate').value,
          'igsttaxrate': this.taxform.get('igsttaxrate').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.taxform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckTax(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.taxform.get('taxid').value > 0) {
                //Update Department
                this.fnSetTax(data);
              }
              else {
                //Insert Department
                this.fnInsertTax(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;

                this.taxform.controls['tax'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertTax(data) {

    this.appService.fnInsertTax(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {

          var result = res.json().result;

          var taxid = 0;
          if (result.length > 0) {
            taxid = result[0].taxid
          }
          this.toastr.success('', "The New Tax has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.taxid);

          this.emitData.emit(this.taxid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetTax(data) {

    this.appService.fnSetTax(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The Tax has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.taxid, data.tax);

          this.emitData.emit(this.taxid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }
  fngetTaxrate() {


    this.taxrate = 0;
    var _cgsttaxrate = this.taxform.get('cgsttaxrate').value
    var _sgsttaxrate = this.taxform.get('sgsttaxrate').value
    var _igsttaxrate = this.taxform.get('igsttaxrate').value
    if (_cgsttaxrate > 0 && _sgsttaxrate > 0) {
      this.taxrate = Number(_cgsttaxrate) + Number(_sgsttaxrate)

    }
    else {
      this.taxrate = _igsttaxrate
    }
    this.taxform.patchValue({ taxrate: this.taxrate })
  }

  // fnTaxType() {
  //   this.taxrate = 0;
  //   var _cgsttaxrate = '';
  //   var _sgsttaxrate = '';
  //   var _igsttaxrate = '';
  //   for (let row of this.settingscompanyColl) {
  //     if(row.settingsvalue==="GST"){
        
  //     }
  //   }

    // this.taxform.patchValue({ 'country': _country })
    // this.fngetState();
    // this.taxform.patchValue({ 'state': _state })
  // }


  private fnEditMode(deptBO) {

    this.taxform.setValue({

      taxid: deptBO.taxid,
      taxname: deptBO.taxname,
      taxrate: deptBO.taxrate,
      cgsttaxrate: deptBO.cgsttaxrate,
      sgsttaxrate: deptBO.sgsttaxrate,
      igsttaxrate: deptBO.igsttaxrate,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
